import { useEffect, useState, type ComponentType } from "react";
import { loadStartupEnvironment, type BootstrapPolicy, type EnvironmentConfig } from "./environment";

type Runtime = ComponentType<{ environment: EnvironmentConfig }>;
const loadRuntime = async (): Promise<Runtime> => (await import("../DesktopRuntime")).DesktopRuntime;

export function DesktopBootstrap({ policy, runtimeLoader = loadRuntime }: {
  policy: BootstrapPolicy;
  runtimeLoader?: () => Promise<Runtime>;
}) {
  const [state, setState] = useState<
    { status: "loading" | "blocked" } | { status: "ready"; Runtime: Runtime; environment: EnvironmentConfig }
  >({ status: "loading" });

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState({ status: "loading" });
    void loadStartupEnvironment(policy, controller.signal).then(async (environment) => {
      if (!active) return;
      const Runtime = await runtimeLoader();
      if (active) setState({ status: "ready", Runtime, environment });
    }).catch(() => { if (active) setState({ status: "blocked" }); });
    return () => { active = false; controller.abort(); };
  }, [policy, runtimeLoader]);

  if (state.status === "ready") return <state.Runtime environment={state.environment} />;
  return <main className="startup-screen"><section className="card state-panel" role={state.status === "blocked" ? "alert" : "status"}>
    <h1>{state.status === "blocked" ? "PocketWatch cannot start" : "Starting PocketWatch"}</h1>
    <p>{state.status === "blocked" ? "The deployment configuration is unavailable or invalid. Contact your PocketWatch administrator." : "Checking deployment configuration…"}</p>
  </section></main>;
}
